// ===== 1. Calcular totales de PO =====
export const baseOfPO = (po) =>
  (po.items || []).reduce((s, it) => s + (Number(it.base) || 0), 0);

export const realizedOfPO = (po, invoicesIndex) =>
  (invoicesIndex?.[po.id] || []).reduce(
    (s, r) => s + (Number(r.baseAmount) || 0),
    0
  );

export const committedOfPO = (po, invoicesIndex) =>
  Math.max(baseOfPO(po) - realizedOfPO(po, invoicesIndex), 0);

// ===== 2. Generar lista plana de facturas (para InvoicePanel) =====
export const flattenInvoices = (invoicesIndex, pos) => {
  const rows = [];
  Object.entries(invoicesIndex || {}).forEach(([poId, list]) => {
    const po = pos.find((p) => p.id === poId);
    (list || []).forEach((inv) =>
      rows.push({
        ...inv,
        _poId: poId,
        _po: po,
        poNumber: po?.number || "",
      })
    );
  });
  return rows;
};
